import Tooltip from './Tooltip'
import './Tooltip.sass'

export default Tooltip
